import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { addOrderReceivedMethodApi, deleteOrderReceivedMethodApi, getOrderReceivedMethodApi, updateOrderReceivedMethodApi } from "../../../services/partners/settings/orderReceivedMethodService";


export const getAllPartnerOrderReceivedMethods = createAsyncThunk("partner/getAllPartnerOrderReceivedMethods", async (filters, { dispatch }) => {
  const response = await getOrderReceivedMethodApi(filters);
  return response.response;
});

export const addPartnerOrderReceivedMethods = createAsyncThunk("partner/addPartnerOrderReceivedMethods", async (duration, { dispatch, getState }) => {
  try {
    const response = await addOrderReceivedMethodApi(duration);
    const data = await response.response;
    toast.success("Add Partner Order Received Method successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const updatePartnerOrderReceivedMethods = createAsyncThunk("partner/updatePartnerOrderReceivedMethods", async (duration, { dispatch, getStatus }) => {
  try {
    const response = await updateOrderReceivedMethodApi(duration, duration.id);
    const data = await response.response;
    toast.success("Update Order Received Method successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const deletePartnerOrderReceivedMethods = createAsyncThunk("partner/deletePartnerOrderReceivedMethods", async (id, { dispatch, getStatus }) => {
  try {
    const response = await deleteOrderReceivedMethodApi(id);
    const data = await response.response;
    toast.success("Deleted Order Received Method successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

const partnerOrderReceivedMethodsAdapter = createEntityAdapter({});

export const { selectAll: selectPartnerOrderReceivedMethods, selectById: selectPartnerOrderReceivedMethodsId } = partnerOrderReceivedMethodsAdapter.getSelectors(
  (state) => state.partner.partnerOrderReceivedMethods
);

const partnerOrderReceivedMethodsSlice = createSlice({
  name: "partnerOrderReceivedMethods",
  initialState: partnerOrderReceivedMethodsAdapter.getInitialState({
    searchText: "",
    addDialog: {
      component: "PartnerOrderReceivedMethods",
      type: "new",
      props: {
        open: false,
      },
      data: null,
    },
  }),
  reducers: {
    setPartnerOrderReceivedMethodsSearchText: {
      reducer: (state, action) => {
        state.searchText = action.payload;
      },
      prepare: (event) => ({ payload: event.target.value || "" }),
    },
    openNewDialog: (state, action) => {
      state.addDialog = {
        component: "PartnerOrderReceivedMethods",
        type: "new",
        props: {
          isOpen: true,
        },
        data: null,
      };
    },
    openEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: true,
        },
        data: action.payload,
      };
    },
    closeEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: false,
        },
        data: null,
      };
    },
  },
  extraReducers: {
    [getAllPartnerOrderReceivedMethods.fulfilled]: partnerOrderReceivedMethodsAdapter.setAll,
  },
});

export const { setPartnerOrderReceivedMethodsSearchText, openNewDialog, closeNewDialog, openEditDialog, closeEditDialog } = partnerOrderReceivedMethodsSlice.actions;

export default partnerOrderReceivedMethodsSlice.reducer;
